export class SettingsEvents {
	public static readonly TOGGLE_ALL_SOUND_OFF: string = 'SettingsEvents::TOGGLE_ALL_SOUND_OFF';
	public static readonly TOGGLE_ALL_SOUND_ON: string = 'SettingsEvents::TOGGLE_ALL_SOUND_ON';

	public static readonly TOGGLE_SOUND_EFFECTS_OFF: string = 'SettingsEvents::TOGGLE_SOUND_OFF';
	public static readonly TOGGLE_SOUND_EFFECTS_ON: string = 'SettingsEvents::TOGGLE_SOUND_ON';

	public static readonly TOGGLE_VOICE_OFF: string = 'SettingsEvents::TOGGLE_VOICE_OFF';
	public static readonly TOGGLE_VOICE_ON: string = 'SettingsEvents::TOGGLE_VOICE_ON';

	public static readonly TOGGLE_MUSIC_OFF: string = 'SettingsEvents::TOGGLE_MUSIC_OFF';
	public static readonly TOGGLE_MUSIC_ON: string = 'SettingsEvents::TOGGLE_MUSIC_ON';

	public static readonly TOGGLE_QUICKSPIN_OFF: string = 'SettingsEvents::TOGGLE_QUICKSPIN_OFF';
	public static readonly TOGGLE_QUICKSPIN_ON: string = 'SettingsEvents::TOGGLE_QUICKSPIN_ON';

	public static readonly TOGGLE_SPACEBAR_OFF: string = 'SettingsEvents::TOGGLE_SPACEBAR_OFF';
	public static readonly TOGGLE_SPACEBAR_ON: string = 'SettingsEvents::TOGGLE_SPACEBAR_ON';

	public static readonly TOGGLE_SKIP_INTRO_ON: string = 'SettingsEvents::TOGGLE_SKIP_INTRO_ON';
	public static readonly TOGGLE_SKIP_INTRO_OFF: string = 'SettingsEvents::TOGGLE_SKIP_INTRO_OFF';

	public static readonly TOGGLE_FAST_PLAY_ON: string = 'SettingsEvents::TOGGLE_FAST_PLAY_ON';
	public static readonly TOGGLE_FAST_PLAY_OFF: string = 'SettingsEvents::TOGGLE_FAST_PLAY_OFF';

	public static readonly TOGGLE_DRAG_REEL_TO_SPIN_ON: string = 'SettingsEvents::TOGGLE_DRAG_REEL_TO_SPIN_ON';
	public static readonly TOGGLE_DRAG_REEL_TO_SPIN_OFF: string = 'SettingsEvents::TOGGLE_DRAG_REEL_TO_SPIN_OFF';
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/modules/mainmenu/settingsmenu/SettingsEvents.ts